<div fxLayoutGap="20px" fxLayout="column" fxFlex>
  <div fxLayoutAlign.gt-md="space-between start">
    <h1>Registro de Acordo do Examinador</h1>

    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center">
      <app-back-button (back)="voltar()"></app-back-button>
      <a mat-stroked-button color="primary" [href]="concursoLink" *ngIf="concursoLink && isLoggedIn()" target="_blank">
        <mat-icon>link</mat-icon> Acessar concurso
      </a>
    </div> 
  </div>
  <div *ngIf="errorFetchingData; else content">
    <mat-card class="card-danger">
      <mat-icon color="warn">error</mat-icon>
      <div>Erro ao carregar os dados. Tente novamente mais tarde.</div>
      <div>Caso o erro persista, peça ao responsável pelo concurso para enviar o email de notificação novamente e acesse com o novo link.</div>
    </mat-card>
  </div>

  <ng-template #content>
    <mat-card class="card-success card-icon" *ngIf="!!dadosComissaoJulgadora?.deAcordoAt">
      <mat-icon>check_circle</mat-icon>
      Declaração assinada e enviada com sucesso em {{ dadosComissaoJulgadora?.deAcordoAt | date : 'dd/MM/yyyy' }} às {{ dadosComissaoJulgadora?.deAcordoAt | date : 'HH:mm' }}.
    </mat-card>

    <mat-card>
      <mat-card-content>
        <form [formGroup]="form" disabled fxLayout="column" fxLayoutGap="20px">
          <fieldset fxFlex="100%">
            <legend>Dados do concurso</legend>

            <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Unidade</mat-label>
                <input matInput formControlName="unidade" readonly />
              </mat-form-field>
            </div>
          </fieldset>
          <fieldset>
            <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Tipo de concurso</mat-label>
                <input matInput formControlName="tipoConcurso" readonly />
              </mat-form-field>
            </div>
          </fieldset>
          <fieldset>
            <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Título</mat-label>
                <input matInput formControlName="tituloConcurso" readonly />
              </mat-form-field>
            </div>
          </fieldset>
          <fieldset>
            <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Aplicação Prova Fase I</mat-label>
                <input matInput formControlName="dataProvaFase1" readonly />
              </mat-form-field>

              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Aplicação Prova Fase II</mat-label>
                <input matInput formControlName="dataProvaFase2" readonly />
              </mat-form-field>
            </div>
          </fieldset>
          <fieldset>
            <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Email de contato</mat-label>
                <input matInput formControlName="emailContato" readonly />
              </mat-form-field>
            </div>
          </fieldset>
          <fieldset>
            <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Email do Departamento</mat-label>
                <input matInput formControlName="emailDepartamento" readonly />
              </mat-form-field>
            </div>
          </fieldset>
          <fieldset fxFlex="100%">
            <legend>Dados do examinador</legend>

            <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Nome</mat-label>
                <input matInput formControlName="nomeExaminador" readonly />
              </mat-form-field>
            </div>
          </fieldset>
          <fieldset>
            <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Email</mat-label>
                <input matInput formControlName="emailExaminador" readonly />
              </mat-form-field>

              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Matrícula</mat-label>
                <input matInput formControlName="matricula" readonly />
              </mat-form-field>
            </div>
          </fieldset>
          <fieldset>
            <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Unidade</mat-label>
                <input matInput formControlName="unidade" readonly />
              </mat-form-field>

              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Papel</mat-label>
                <input matInput formControlName="papelExaminador" readonly />
              </mat-form-field>
            </div>
          </fieldset>
        </form>
      </mat-card-content>
      <mat-card-actions>
        <div
          fxLayoutAlign.gt-md="space-between center"
          fxLayoutAlign.lt-md="center stretch"
          fxLayout.lt-md="column"
          fxLayoutGap="20px">
          <button 
            mat-raised-button 
            color="primary" 
            (click)="openDialog()" 
            *ngIf="!dadosComissaoJulgadora?.deAcordoAt"
            id="btn-visualizar-documento">
            <mat-icon>done</mat-icon> Visualizar Documento para Registrar De Acordo
          </button>

          <app-cancel-button (cancel)="fechar()"></app-cancel-button>
        </div>
      </mat-card-actions>
    </mat-card>
  </ng-template>
</div>
